import { render } from "./IPInspirationView.vue?vue&type=template&id=5650498e&ts=true"
import script from "./IPInspirationView.vue?vue&type=script&lang=ts"
export * from "./IPInspirationView.vue?vue&type=script&lang=ts"

import "./IPInspirationView.vue?vue&type=style&index=0&id=5650498e&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__